/**
 * Calculates the Probability Density Function (PDF) for a wald distribution.
 * @param x The value on the x-axis.
 * @returns The probability density at point x.
 */
const waldPDF = (x: number) => {
  if (x <= 0) return 0 // PDF is defined for x > 0 and positive parameters
  // https://docs.scipy.org/doc/scipy/reference/generated/scipy.stats.wald.html#scipy.stats.wald
  // https://github.com/scipy/scipy/blob/main/scipy/stats/_continuous_distns.py#L5047
  // https://github.com/scipy/scipy/blob/main/scipy/stats/_continuous_distns.py#L11351
  const term1 = 1 / Math.sqrt(2 * Math.PI * Math.pow(x, 3))
  const exponent = Math.pow(x - 1, 2) / (2 * x)
  const term2 = Math.exp(-exponent)
  return term1 * term2
}

/**
 * Generates an array of {x, y} points for the Wald distribution curve.
 * @param loc The loc is x-axis shift
 * @param scale scale is x-axis and y-axis shift
 * @param lbound - Lower boundary for data.
 * @param ubound - Upper boundary for data.
 * @param numPoints The number of points to calculate.
 * @returns An array of objects, e.g., [{x: 0.1, y: 0.8}, ...].
 */
export const waldSample = (
  loc: number,
  scale: number,
  lbound?: number,
  ubound?: number,
  numPoints = 1000,
) => {
  const data = []
  const step = 0.01
  for (let i = 1; i <= numPoints; i++) {
    const x = i * step
    const y = waldPDF(x) / scale
    if (lbound && x < lbound) continue
    if (ubound && x > ubound) continue
    data.push({ x: x * scale + loc, y: y })
  }
  return data
}
